/**
 * Tiny pub/sub backing the routine-change pop-out (see RoutineChangeToast).
 * Module-level so any routine mutation can fire a confirmation chip without
 * threading a context through the whole workflows tree.
 */

export interface RoutineChip {
  id: number;
  label: string;
}

let chips: RoutineChip[] = [];
let seq = 0;
const listeners = new Set<(next: RoutineChip[]) => void>();
const DISMISS_MS = 2200;

const emit = () => {
  const snapshot = chips;
  listeners.forEach((fn) => fn(snapshot));
};

const removeChip = (id: number) => {
  chips = chips.filter((chip) => chip.id !== id);
  emit();
};

/** Current chips — used to seed the toaster's initial render. */
export const getRoutineChips = (): RoutineChip[] => chips;

/** Subscribe to chip changes; returns an unsubscribe. */
export const subscribeRoutineChips = (
  fn: (next: RoutineChip[]) => void
): (() => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

/** Pop a routine-change confirmation chip. Fire this on a successful edit. */
export const showRoutineChange = (label: string): void => {
  const id = (seq += 1);
  chips = [...chips, { id, label }];
  emit();
  // Self-dismiss; AnimatePresence plays the collapse-and-swipe exit on removal.
  setTimeout(() => removeChip(id), DISMISS_MS);
};
